import React, { useEffect, useState, useContext } from 'react';
import Navbar from 'react-bootstrap/Navbar';
import logoBranca from '../../assets/logo-branca.png';
import Nav from 'react-bootstrap/Nav';
import { useNavigate } from 'react-router-dom';
import DropDownMenu from './DropDownMenu';
import SessionContext from '../../contexts/SessionContext';
import { getTranslatedTexts } from '../../utils/TranslationUtils';
import config from '../../config';

const SimpleNavbar = (props) => {
	const navigate = useNavigate();
	let {
		hasRole,
		session_data: { language_preference },
	} = useContext(SessionContext);
	const [texts, setTexts] = useState(null);

	const pageAccess = (e, page) => {
		navigate(page);
		e.preventDefault();
	};

	const logout = (e) => {
		if (e) e.preventDefault();
		// limpa o token local e envia para o logout do servico de autenticacao
		window.localStorage.removeItem('auth_token');
		window.location.href = config.orb_logout_url;
	};

	useEffect(() => {
		const translatedTexts = getTranslatedTexts('menu', language_preference);
		setTexts(translatedTexts);
	}, [language_preference]);

	return (
		<Navbar
			/*fixed="top"*/ collapseOnSelect
			expand='lg'
			variant='dark'
			style={{ backgroundColor: '#111' }}
		>
			<Navbar.Brand href=''>
				<img
					className='logo-navbar'
					src={logoBranca}
					alt='orb logo'
					height={40}
					width={40}
				/>
			</Navbar.Brand>
			<Navbar.Toggle aria-controls='basic-navbar-nav' />
			<Navbar.Collapse id='basic-navbar-nav'>
				<Nav>
					{hasRole([
						'TRACKS',
						'WORKS',
						'CLIENTS',
						'CONTRIBUTORS',
						'AGENTS',
					]) ? (
						<DropDownMenu
							path='register'
							className={
								props.selectedOption === 'drop_register'
									? 'nav-link active'
									: 'nav-link'
							}
							title={texts ? texts.register : ''}
							list={texts ? texts.register_items : []}
							roles={[
								['WORKS'],
								['TRACKS'],
								['LABELS'],
								['PUBLISHERS'],
								['CONTRIBUTORS'],
								['CLIENTS'],
								['AGENTS'],
							]}
							pageAccess={pageAccess}
						/>
					) : null}

					{hasRole(['PAYMENT_FILE_WORKS', 'PAYMENT_FILE_TRACKS']) ? (
						<DropDownMenu
							path='files'
							className={
								props.selectedOption === 'drop_files'
									? 'nav-link active'
									: 'nav-link'
							}
							title={texts ? texts.files : ''}
							list={texts ? texts.files_items : []}
							roles={[
								['PAYMENT_FILE_WORKS'],
								['PAYMENT_FILE_TRACKS'],
							]}
							pageAccess={pageAccess}
						/>
					) : null}

					{hasRole(['DISTRIBUTIONS']) ? (
						<>
							<Nav.Link
								className={
									props.selectedOption ===
									'drop_distributions'
										? 'nav-link active'
										: 'nav-link'
								}
								onClick={(e) => pageAccess(e, `/distributions`)}
							>
								{texts ? texts.distributions : ''}
							</Nav.Link>
						</>
					) : null}

					<Nav.Link
						className={
							props.selectedOption === 'drop_reports'
								? 'nav-link active'
								: 'nav-link'
						}
						onClick={(e) => pageAccess(e, `/reports`)}
					>
						{texts ? texts.reports : ''}
					</Nav.Link>

					<DropDownMenu
						path='dashboard'
						className={
							props.selectedOption === 'drop_dashboard'
								? 'nav-link active'
								: 'nav-link'
						}
						title='Dashboard'
						list={texts ? texts.dashboards_items : []}
						roles={[['DASHBOARD_WORKS'], ['DASHBOARD_TRACKS']]}
						pageAccess={pageAccess}
					/>

					{hasRole(['ADMIN']) ? (
						<DropDownMenu
							path='admin'
							className={
								props.selectedOption === 'drop_admin'
									? 'nav-link active'
									: 'nav-link'
							}
							title={texts ? texts.admin : ''}
							list={texts ? texts.admin_items : []}
							roles={[
								['USERS_WRITE'],
								['GET_FINANCIAL_DATA'],
								[
									'PAYMENT_FILE_TRACKS_WRITE',
									'PAYMENT_FILE_WORKS_WRITE',
								],
							]}
							pageAccess={pageAccess}
						/>
					) : null}
				</Nav>
				<Nav style={{ marginLeft: 'auto' }}>
					<Nav.Link className='nav-link' onClick={logout}>
						{texts ? texts.session_logout : 'Sair'}
					</Nav.Link>
				</Nav>
			</Navbar.Collapse>
		</Navbar>
	);
};

export default SimpleNavbar;
